export const objects = [
  "Bubble Wrap",
  "Rubbish Bin",
  "Scratch Post",
  "Computer Monitor",
  "Tissue",
  "Shotgun",
  "Kilt",
  "Sock",
  "Portrait",
  "Paper Clip",
  "Bullet",
  "Rung",
  "Blackboard",
  "Satellite Dish",
  "Beard",
  "Antler",
  "Bonfire",
  "Mask",
  "Ladle",
  "Bunsen Burner",
  "Christmas Cracker",
];